import classes from "./nuova-sabatini-table.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
function NuovaSabatiniTable() {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.table}
    >
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.header}>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          SABATINI 4.0
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          SABATINI GREEN{" "}
        </Label>
        <Label
          tag="p"
          size="md"
          color="default"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          SABATINI CAPITALIZZAZIONE
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          {
            "2,75% per gli investimenti ordinari\n3,575% per gli investimenti 4.0"
          }
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          3,575% per gli investimenti green
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          {"5% per le micro e piccole imprese\n3,575% per le medie imprese"}
        </Label>
      </Grid>
      <Grid columnGap={"2px"} columns="1fr 1fr 1fr" className={classes.row}>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.firstColumn, classes.item)}
        >
          Beni immateriali 4.0 (Allegato B, legge n. 232/2016)
        </Label>

        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.secondColumn, classes.item)}
        >
          20% per investimenti fino a 1 milione €
        </Label>
        <Label
          tag="p"
          size="md"
          color="secondary"
          align="start"
          weight="bold"
          className={classNames(classes.thirdColumn, classes.item)}
        >
          {
            "2023: 20% per investimenti fino a 1 milione €\n2024: 15% per investimenti fino a 1 milione €\n2025: 10% per investimenti fino a 1 milione €"
          }
        </Label>
      </Grid>
    </Flex>
  );
}

export default NuovaSabatiniTable;
